import React from 'react';
import FormImporter from '../../components/FormImporter';

export default function ImportFillout() {
  return (
    <FormImporter
      platform="fillout"
      slug="import-from-fillout"
      platformName="Fillout"
      metaTitle="Fillout Importer: Free 1-Click Migration | Fantastic Forms"
      tagline="Moving from Fillout? Paste your public form URL and Fantastic Forms will extract the field structure into a clean JSON schema, ready to drop into a new form."
      urlExample="https://forms.fillout.com/t/xxxxxxxxxxxx"
      helpText="Use the direct Fillout sharing URL. Note: Fillout renders forms entirely via JavaScript, so the public HTML may not expose every field. If extraction returns few fields, contact us with your Fillout form URL and we'll help migrate the definition manually."
    />
  );
}
